import { render, staticRenderFns } from "./DeliverableAssetsList.vue?vue&type=template&id=770128a0&scoped=true"
import script from "./DeliverableAssetsList.vue?vue&type=script&lang=js"
export * from "./DeliverableAssetsList.vue?vue&type=script&lang=js"
import style0 from "./DeliverableAssetsList.vue?vue&type=style&index=0&id=770128a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770128a0",
  null
  
)

export default component.exports